import * as React from "react";
import {ThemeProvider} from "@vebox/etui-system";
import {HashRouter, Route, Routes} from "react-router-dom";
import {ErrorBoundary} from "../../ErrorBoundary/ErrorBoundary";
import {DefaultErrorBoundaryFallback} from "../../ErrorBoundary/DefaultErrorBoundaryFallback";

import "./massiveActionsStyles.scss";
import {PackagesClaim} from "./packagesClaim/PackagesClaim";
import {veboxDefaultTheme} from "../../index";
import {PackagesProvider} from "./packagesClaim/PackagesProvider";
import {ChangeEquipmentStatus} from "./changeEquipmentStatus/ChangeEquipmentStatus";
import {LockUnlockEquipmentCompressor} from "./lockUnlockEquipmentCompressor/LockUnlockEquipmentCompressor";
import {MassiveActionsProvider} from "./MassiveActionsProvider";
import {AvailableMassivePatch, MassiveActions, MassiveActionsControllerProps} from "./MassiveActionsTypesAndFunctions";
import {RedirectPage} from "./components/RedirectPage";
import {
    LockUnlockEquipmentCompressorProvider
} from "./lockUnlockEquipmentCompressor/LockUnlockEquipmentCompressorProvider";
import {ChangeEquipmentStatusProvider} from "./changeEquipmentStatus/ChangeEquipmentStatusProvider";
import {DATA_STATE} from "../../users/contexts/UsersDashboardContext";
import {getAvailableMassivePatches, isCensusAvailable} from "./MassiveActionsController";
import {NotAvailableMassiveAction} from "./NotAvailableMassiveAction";
import {ProtectedRoute} from "./ProtectedRoute";
import {HeartBeat} from "./heartBeat/HeartBeat";
import {CensusCooler} from "./CensusCooler";
import {JSONCensusAvailabilityCheckResult} from "./CensusCooler/data/models/JSONCensusAvailabilityCheckResult";
import {DataResponse} from "./CensusCooler/data/models/RestApi";
import {EquipmentDeletionProcess} from "./EquipmentDeletion";
import {LocationsDeletionProcess} from "./LocationDeletion";


export const MassiveActionsMainPage: React.FC<MassiveActionsControllerProps> = ({massiveAction, stackManager}) => {

    const [availableMassivePatches, setAvailableMassivePatches] = React.useState<AvailableMassivePatch[]>([]);
    const [availableMassiveState, setsAvailableMassiveState] = React.useState<DATA_STATE>(DATA_STATE.loaded);
    const [isCensusFeatureAvailable, setIsCensusFeatureAvailable] = React.useState<DataResponse<JSONCensusAvailabilityCheckResult>>(
        {isLoading: true});

    React.useEffect(() => {

        Promise.all([getAvailableMassivePatches(), isCensusAvailable()])
            .then(([list, isCensusAvailable]) => {
                setIsCensusFeatureAvailable({isLoading: false, data: isCensusAvailable});
                const massiveCensus: AvailableMassivePatch = {
                    name: MassiveActions.CENSUS_COOLER,
                    patch: "newCensus",
                    value: [],
                    available: isCensusAvailable?.supported,
                    emailReceivers: []
                }
                setAvailableMassivePatches([...list, massiveCensus]);
                setsAvailableMassiveState(DATA_STATE.loaded);
            })
            .catch((error) => {
                console.error(error);
                setIsCensusFeatureAvailable({isLoading: false, error});
                setsAvailableMassiveState(DATA_STATE.error)
            })
    }, []);
    return (
        <ThemeProvider theme={veboxDefaultTheme}>
            <div className={"massive-actions"}>
                <ErrorBoundary fallback={<DefaultErrorBoundaryFallback/>}>
                    <MassiveActionsProvider
                        availableMassivePatchesInfo={{
                            availableMassiveState,
                            availableMassivePatches
                        }}
                        stackManager={stackManager}
                    >
                        <HashRouter basename={"/"}>
                            <RedirectPage
                                massiveAction={massiveAction}
                                availableMassivePatchesInfo={{
                                    availableMassiveState,
                                    availableMassivePatches
                                }}
                            />
                            <Routes>
                                <Route
                                    path={"/packagesClaim"}
                                    element={
                                        <PackagesProvider>
                                            <PackagesClaim/>
                                        </PackagesProvider>
                                    }
                                />
                                <Route
                                    path={"/equipmentDeletion"}
                                    element={
                                        <EquipmentDeletionProcess/>
                                    }
                                />
                                <Route
                                    path={"/locationsDeletion"}
                                    element={
                                        <LocationsDeletionProcess/>
                                    }
                                />
                                <Route
                                    path={"/lockUnlockEquipmentCompressor"}
                                    element={
                                        <ProtectedRoute availableMassivePatches={availableMassivePatches}>
                                            <LockUnlockEquipmentCompressorProvider>
                                                <LockUnlockEquipmentCompressor/>
                                            </LockUnlockEquipmentCompressorProvider>
                                        </ProtectedRoute>
                                    }
                                />
                                <Route
                                    path={"/changeEquipmentStatus"}
                                    element={
                                        <ProtectedRoute availableMassivePatches={availableMassivePatches}>
                                            <ChangeEquipmentStatusProvider>
                                                <ChangeEquipmentStatus/>
                                            </ChangeEquipmentStatusProvider>
                                        </ProtectedRoute>
                                    }
                                />
                                <Route
                                    path={"/equipmentHeartBeat"}
                                    element={
                                        <ProtectedRoute availableMassivePatches={availableMassivePatches}>
                                            <HeartBeat/>
                                        </ProtectedRoute>
                                    }
                                />
                                <Route
                                    path={"/censusCooler"}
                                    element={
                                        <ProtectedRoute availableMassivePatches={availableMassivePatches}>
                                            <CensusCooler isCensusFeatureAvailable={isCensusFeatureAvailable}/>
                                        </ProtectedRoute>
                                    }
                                />
                                <Route
                                    path={"/massiveActionNotAvailable"}
                                    element={<NotAvailableMassiveAction/>}
                                />
                            </Routes>
                        </HashRouter>
                    </MassiveActionsProvider>
                </ErrorBoundary>
            </div>
        </ThemeProvider>
    );
}








